<template>
  <div class="grid-map-menu-body">
    <component
      :is="scrollbarTag"
      class="grid-map-scroll-area--customizer pt-4 pb-6"
      :settings="settings"
      :key="$vs.rtl"
    >
      <ul class="mt-1">
        <li
          class="aisea-pb-6 aisea-pl-4 aisea-pr-4"
          v-for="plot in enterprisePrivatePlots"
          :key="plot.hash"
        >
          <private-plot-card
            :plot="plot"
            :jumpToPlot="jumpToPlot"
            :isSelected="trackingTarget === plot.hash"
          />
        </li>
      </ul>
    </component>
  </div>
</template>

<script>
/**
 * マップ右メニューのプライベートプロット一覧を表示するコンポーネント
 * @parent O.RightMenuBase
 */
import * as turf from "@turf/turf";
import { createNamespacedHelpers } from "vuex";
import FireStoreService from "@/services/fireStoreService";
import PrivatePlotCard from "@/components/molecules/PrivatePlotCard";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

const {
  mapMutations: mapMutationsOfGridMap,
  mapState: mapStateOfGridMap,
  mapGetters: mapGettersOfGridMap,
} = createNamespacedHelpers("gridMap");

const { mapGetters: mapGettersOfPrivatePlot } =
  createNamespacedHelpers("gkmgPrivatePlot");

export default {
  name: "O.PrivatePlot",
  components: {
    PrivatePlotCard,
    VuePerfectScrollbar,
  },
  props: {
    /** スクロールの設定 */
    settings: {
      type: Object,
      required: true,
    },
    /** 法人ID */
    enterpriseId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    ...mapStateOfGridMap({
      activeSidebarForGrid: (state) => state.activeSidebarForGrid,
    }),
    ...mapGettersOfPrivatePlot(["getEnterprisePrivatePlots"]),
    ...mapGettersOfGridMap(["getTrackingTarget"]),
    enterprisePrivatePlots() {
      return this.getEnterprisePrivatePlots(this.enterpriseId);
    },
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
    // FireStoreで追跡設定しているターゲットがplotならIDを返す
    trackingTarget() {
      return this.getTrackingTarget({
        mapId: this.activeSidebarForGrid.mapId,
        type: "privatePlot",
      });
    },
  },
  methods: {
    ...mapMutationsOfGridMap([
      "UPDATE_GRID_MAP_SETTINGS",
      "UPDATE_LAST_TRACKING_POSITION",
    ]),
    // 選択したプロットの座標にズームされる
    async jumpToPlot(plot) {
      if (!plot || !plot.points || !plot.points.length) {
        this.showFailureMessage();
        return;
      }
      const mapId = this.activeSidebarForGrid.mapId;
      if (!mapId) {
        this.showFailureMessage();
        return;
      }
      // 選択中のカードをクリックしたら選択を解除しデフォルトポジションに戻る
      if (this.trackingTarget === plot.hash) {
        this.UPDATE_LAST_TRACKING_POSITION({
          mapId: mapId,
          center: [],
        });
        return;
      }
      const collections = plot.points.map((e) => {
        return turf.point([e.longitude, e.latitude]);
      });
      if (!collections || !collections.length) {
        this.showFailureMessage();
        return;
      }
      const features = turf.featureCollection(collections);
      const center = turf.center(features);
      // store(vuex)更新
      this.UPDATE_LAST_TRACKING_POSITION({
        mapId: mapId,
        center: center.geometry.coordinates,
      });
      this.UPDATE_GRID_MAP_SETTINGS({
        map_id: mapId,
        tracking_target: { type: "privatePlot", id: plot.hash },
      });
      // FireStore更新
      await FireStoreService.setGridMapSettings(mapId, {
        tracking_target: { type: "privatePlot", id: plot.hash },
      });
    },
    // 位置情報取得に失敗したときのメッセージ
    showFailureMessage() {
      this.$vs.notify({
        title: "位置情報がありません",
        color: "warning",
        iconPack: "feather",
        icon: "icon-alert-circle",
      });
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
</style>
